import * as React from 'react';
import styled from 'styled-components';
import {mixinBtnLarge, mixinResetBtnCss, mixinBtnCorporate, mixinWithBtnPropsFn, IBtnDefaultProps} from "./btn_mixin";
import {Link, LinkProps} from "react-router-dom";

interface IProps
    extends IBtnDefaultProps, LinkProps {
}

const BtnLinkCorporateLargeDefault: React.FC<IProps> = (props) => {

    const { icon, widthSize, ...ButtonProps } = props;

    return (<Link {...ButtonProps} />)

};

const BtnLinkCorporateLarge = styled(BtnLinkCorporateLargeDefault)`
    ${mixinResetBtnCss}
    ${mixinBtnLarge}
    ${mixinBtnCorporate}
    
    ${props => mixinWithBtnPropsFn(props)}
`;

export default BtnLinkCorporateLarge;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/btn/btn_link_corporate_large.tsx